import { render, staticRenderFns } from "./PreviewFileComponent.vue?vue&type=template&id=51413312&scoped=true"
import script from "./PreviewFileComponent.vue?vue&type=script&lang=js"
export * from "./PreviewFileComponent.vue?vue&type=script&lang=js"
import style0 from "./PreviewFileComponent.vue?vue&type=style&index=0&id=51413312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51413312",
  null
  
)

export default component.exports